import React from 'react';

function toDate(value) {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value?.toDate === 'function') return value.toDate();
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function formatDateTime(value) {
  const date = toDate(value);
  if (!date) return '—';
  return date.toLocaleString(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
}

export default function DetailTimestampsFooter({
  createdAt,
  updatedAt,
  lastViewedAt,
  importedOn,
  createdFallback = null,
  updatedFallback = null,
}) {
  const added = createdAt || updatedAt || lastViewedAt || createdFallback;
  const updated = updatedAt || createdAt || lastViewedAt || updatedFallback;
  const viewed = lastViewedAt;
  const imported = importedOn;

  return (
    <div className="detail-timestamps-footer">
      <p className="detail-timestamps-row"><strong>Added:</strong> {formatDateTime(added)}</p>
      <p className="detail-timestamps-row"><strong>Updated:</strong> {formatDateTime(updated)}</p>
      <p className="detail-timestamps-row"><strong>Last viewed:</strong> {formatDateTime(viewed)}</p>
      {imported ? <p className="detail-timestamps-row"><strong>Imported on:</strong> {formatDateTime(imported)}</p> : null}
    </div>
  );
}
